//
//  app.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
    computed: {
        ...mapState('dataModule', ['backgroundOnLoading']),
    },
})
export default class App extends Vue {

    private backgroundOnLoading!: string;

}
